<template>
  <v-navigation-drawer id="core-navigation-drawer" v-model="drawer"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'" :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl" :src="barImage" mobile-break-point="960" app mini-variant-width="80" width="260"
    v-bind="$attrs">
    <template v-slot:img="props">
      <v-img :gradient="`to bottom, ${barColor}`" v-bind="props" />
    </template>

    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title class="text-uppercase font-weight-regular display-2">
          <span class="logo-mini">{{ $t("ct") }}</span>
          <span class="logo-normal">{{ $t("tim") }}</span>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider class="mb-1" />

    <v-list expand nav>
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />

      <template v-for="(item, i) in computedItems">
        <base-item-group v-if="item.children" :key="`group-${i}`" :item="item">
          <!--  -->
        </base-item-group>

        <base-item v-else :key="`item-${i}`" :item="item" />
      </template>

      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />
    </v-list>
  </v-navigation-drawer>
</template>

<script>
//import axios from "axios";
// Utilities
import { mapState } from "vuex";

export default {
  name: "DashboardCoreDrawer",

  props: {
    expandOnHover: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    items: [],
  }),
  computed: {
    ...mapState(["barColor", "barImage"]),
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(val) {
        this.$store.commit("SET_DRAWER", val);
      },
    },
    computedItems() {
      return this.items.map(this.mapItem);
    },
    profile() {
      return {
        avatar: false,
        group: "",
        title: this.$t("avatar"),
        children: [
          {
            href: "",
            title: "Log Off", //this.$t('my-profile'),
          },
          /*
            {
              to: '',
              title: this.$t('edit-profile'),
            },
            {
              to: '',
              title: this.$t('settings'),
            },
            */
        ],
      };
    },
  },

  watch: {
    "$vuetify.breakpoint.smAndDown"(val) {
      this.$emit("update:expandOnHover", !val);
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      console.log("Inicializar drawer !!");
      let me = this;
      // me.createMenu();
      // if (localStorage.getItem("rol") == "admin") 
      //{
      me.items = [
        {
          icon: "mdi-view-dashboard",
          title: "dashboard",
          to: "/dashboard",
        },
        {
          group: "/components",
          icon: "mdi-account-group",
          title: "IoT",
          children: [
            {
              title: "Detalle por sensor",
              to: "DetallePorSensor",
            },
            {
              title: "Consolidador",
              to: "consolidador",
            },
          ],
        },
        {
          group: "/components",
          icon: "mdi-security",
          title: "Cuentas x c",
          children: [
            {
              title: "Generar",
              to: "GenerarFactura",
            },
            {
              title: "Registro de pagos",
              to: "RegistroPago",
            },
              {
              title: "Registro de pagos Bot",
              to: "RegistroPagoBot",
            },
            {
              title: "Reportes",
              to: "RegistroPago",
            },
            /*
            {
              title: "Estados de cuenta",
              to: "EstadoCuenta",
            },
            */
          ],
        },
         {
          group: "/components",
          icon: "mdi-security",
          title: "Cuentas x p",
          children: [
            {
              title: "Registrar",
              to: "CuentasPorPagar",
            },
             {
              title: "Reportes",
              to: "CuentasPorPagar",
            },
         
            /*
            {
              title: "Estados de cuenta",
              to: "EstadoCuenta",
            },
            */
          ],
        },
          {
          group: "/components",
          icon: "mdi-security",
          title: "Resumen",
          children: [
            {
              title: "Balance General",
              to: "Balance",
            },
         
            /*
            {
              title: "Estados de cuenta",
              to: "EstadoCuenta",
            },
            */
          ],
        },
        {
          group: "/components",
          icon: "mdi-security",
          title: "Administracion",
          children: [
           
            {
              title: "Urbanizaciones",
              to: "urbanizacion",
            },
            {
              title: "Edificios",
              to: "edificio",
            },
            {
              title: "Propiedades",
              to: "propiedad",
            },
            {
              title: "Grupos",
              to: "grupo",
            },
            {
              title: "Sensores",
              to: "sensor",
            },
              {
              title: "Proveedores",
              to: "proveedor",
            },
          ],
        },
      ];

    },
    mapItem(item) {
      return {
        ...item,
        children: item.children ? item.children.map(this.mapItem) : undefined,
        title: this.$t(item.title),
      };
    },

    /*
      createMenu(){
        console.log("cerated menu  !!!!   !  ! ! ! !  ! !");
        let me = this;
        let header = { Authorization: "Bearer " + this.$store.state.token };
        let configuracion = { headers: header };
        axios
            //.get("api/Users/mainMenu/KCN96533" + localStorage.getItem('unico'),configuracion)
            .get("api/Users/mainMenu/KCN96533",configuracion)
            .then(function(response) {
             
              me.items = response.data;
               console.log(me.items);
            })
            .catch(function(error) {
            console.log(error);
            });
      },
      */
  },
};
</script>

<style lang="sass">
@import '~vuetify/src/styles/tools/_rtl.sass'

#core-navigation-drawer
  &.v-navigation-drawer--mini-variant
    .v-list-item
      justify-content: flex-start !important

      .v-list-group--sub-group
        display: block !important

    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
</style>
